import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import { getTransactionDocDetail } from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import SalesOrderItems from "./sales-order/items";
import SalesOrderBilling from "./sales-order/billing";

export default function TransactionTypeDefault() {
  const snackbar = useSnackbar();
  const [loading, setLoading] = useState(false);
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];
  const [linkingdocumentno, setlinkingdocumentno] = useState("");

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  /*----------------End Tabs-----------------*/

  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, [user.token]);

  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionDocDetail(user.token, {
        tranid: params.docNo,
        type: pageDetail.path,
      });
      setRowData(data.data.details);
      setLoading(false);

      setlinkingdocumentno(data.data.linkingdocumentno);
      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return loading ? (
    <>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Sales Information
          </Typography>
        </Box>

        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Related RMA
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Additional Info
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      {/*Primary Information*/}

      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">Order #</p>
                  <p className="tFormName">{d.tranid}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">DATE</p>
                  <p className="tFormName">{d.trandate}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">HOLD TYPE</p>
                  <p className="tFormName">{d.hold_type}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">BILL TO</p>
                  <p className="tFormName">{d.bill_to}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PO #</p>
                  <p className="tFormName">{d.tranid}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">HOLD REASON</p>
                  <p className="tFormName">{d.custbody_fs_so_hold_reason}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">DISTRIBUTOR</p>
                  <p className="tFormName">
                    {d.custbody_channel_tier_copy_for_globl_s}
                  </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel"> MEMO</p>
                  <p className="tFormName">{d.memo}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SALES ORDER HOLD REASON 1</p>
                  <p className="tFormName">{d.custbody_sales_order_hold}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">RESELLER</p>
                  <p className="tFormName">
                    {d.custbody_reseller_copy_for_globl_s}
                  </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel"> DEAL ID</p>
                  <p>{d.custbody_deal_id}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SALES ORDER HOLD REASON 2</p>
                  <p className="tFormName">{d.custbody_sales_order_hold_2}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">END CUSTOMER</p>
                  <p className="tFormName">
                    {d.custbody_end_customer_copy_for_globl_s}
                  </p>
                </Grid>

                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PROMO CODE</p>
                  <p className="tFormName">{d.custbody_promo_code}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SALES ORDER HOLD DATE 1</p>
                  <p className="tFormName">
                    {d.custbody_sales_order_hold_date_1}
                  </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CHANNEL TIER</p>
                  <p className="tFormName">
                    {d.custbody_channel_tier_copy_for_globl_s}
                  </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">WARNING LINES</p>
                  <p className="tFormName">{d.custbody_warning_lines}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SALES ORDER HOLD DATE 2</p>
                  <p className="tFormName">
                    {d.custbody_sales_order_hold_date_2}
                  </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CHANNEL</p>
                  <p className="tFormName">{d.channel}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">INTERNAL COMMENTS</p>
                  <p className="tFormName">{d.custbody_internal_comments}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">TOTAL</p>
                  <p className="tFormName">{d.foreigntotal}</p>
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
      </Box>

      {/*Sales Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Sales Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SE MAIL</p>
                  <p className="tFormName">{d.custbody_seemail}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SALES ENGINEER</p>
                  <p className="tFormName">{d.custbody_salesenginee}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">OPPTY NUMBER</p>
                  <p className="tFormName">{d.custbody_oppty_number}</p>
                </Grid>
                {d.linkingorderid == null ? null : (
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">CREATED FROM</p>
                    <p className="tFormName">
                      Sales Order <p className="link-color">#</p>
                      <Link
                        className="link-color"
                        target="_blank"
                        to={
                          "/transaction-type/sales-order/" +
                          `${d.linkingorderid}`
                        }
                      >
                        {linkingdocumentno}
                      </Link>
                    </p>
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SALES TERRITORY</p>
                  <p className="tFormName">{d.sales_territory}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">QUOTE NUMBER</p>
                  <p className="tFormName">{d.custbody_quote_number}</p>
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
      </Box>

      {/*Related RMA*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Related RMA
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">RMA #</p>
                  <p className="tFormName">{d.custbody_rma_number}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">RMA CREATED FROM</p>
                  <p className="tFormName">{d.custbody_rma_created_frm}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">RMA RC</p>
                  <p className="tFormName">{d.rma_rc}</p>
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">LICENSE TYPE</p>
                  <p className="tFormName">{d.shipcarrier}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">GEOGRAPHY</p>
                  <p className="tFormName">{d.geography}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">FINANCE COUNTRY</p>
                  <p className="tFormName">{d.finance_country}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CLASS</p>
                  <p className="tFormName">{d.CLASS}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">REGION</p>
                  <p className="tFormName">{d.region}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">FINANCE GEO</p>
                  <p className="tFormName">{d.finance_geo}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">LOCATION</p>
                  <p className="tFormName">{d.transferlocation}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">ORDER TYPE</p>
                  <p className="tFormName">{d.order_type}</p>
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
      </Box>

      {/*Order Review*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Order Review
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">ORDER REVIEW CHECKLIST</p>
                  <p className="tFormName">
                    {d.custbody_order_review_checklist}
                  </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">ORDER REVIEW STATUS</p>
                  <p className="tFormName">
                    {d.custrecord_ordcer_review_status}
                  </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">ORDER REVIEW APPROVED BY</p>
                  <p className="tFormName">
                    {d.custbody_order_review_approved}
                  </p>
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
      </Box>

      {/*Additional Info*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Additional Info
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CASE NUMBER</p>
                  <p className="tFormName">{d.custbodycasenumber}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">DONT SEND ORDER ACK</p>
                  <p className="tFormName">{d.custbody_dont_send_order_ack}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SERIAL NUMBER SEARCH</p>
                  <p className="tFormName">{d.custbody_serial_number_search}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">INVOICE MESSAGING</p>
                  <p className="tFormName">{d.custbody_ava_invoicemessag}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">BILL-TO ENTITY/USE CODE</p>
                  <p className="tFormName">{d.custbody_ava_billtousecode}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PERTNER IDENTIFIED</p>
                  <p className="tFormName">{d.partner_identified}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">IS SELLER IMPORTER RECORD</p>
                  <p className="tFormName">
                    {d.custbody_ava_is_sellerimporter}
                  </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SHIP-TO ENTITY/USE CODE</p>
                  <p className="tFormName">{d.custbody_ava_shiptousecode}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SUBSIDIARY</p>
                  <p className="tFormName">{d.subsidiary}</p>
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
      </Box>
      <Box>
        <Box
          className="viewBox "
          sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Items" />
            <Tab label="Billing" />
            <Tab label="Shipping" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            <SalesOrderItems></SalesOrderItems>
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <SalesOrderBilling></SalesOrderBilling>
          </TabPanel>
          <TabPanel value={tabIndex} index={2}>

          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
